var React = require('react');

function Shape4 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M127.783 160.695C113.793 164.548 98.1549 165.064 83.5402 164.994C57.3661 164.857 27.5818 162.432 11.4226 142.018C-1.9421 125.112 -1.2305 101.377 1.89372 80.1203C5.86842 53.2564 14.6336 24.0363 38.1 10.0196C50.9093 2.36633 66.3395 0.440099 81.2837 0.0445355C114.279 -0.815384 147.344 10.6731 159.806 43.6081C165.655 61.288 170.619 81.3414 170.984 99.9672C171.296 115.858 167.148 132.421 156.387 144.201C148.697 152.629 138.752 157.685 127.783 160.695Z"}));
}

Shape4.defaultProps = {"width":"171","height":"165","viewBox":"0 0 171 165","fill":"none"};

module.exports = Shape4;

Shape4.default = Shape4;
